export default __webpack_public_path__ + "static/media/4.70768d40.jpg";